export default "https://cdn-shared.mathletics.com/teacher-modules/mx-portal/278/assets/images/icon_my_profile-3b0a18f83306c87062ee9548dc96f157.svg";